import {Component, Inject, OnInit} from '@angular/core';
import {TestResult} from '../../../data/models/result/test-result';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-result-delete-dialog',
  templateUrl: './test-result-delete-dialog.component.html',
  styleUrls: ['./test-result-delete-dialog.component.css']
})
export class TestResultDeleteDialogComponent implements OnInit {

  testResult: TestResult;

  constructor(
    private testResultService: TestResultService,
    public dialogRef: MatDialogRef<TestResultDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      testResult: TestResult,
    },
  ) {
    this.testResult = data.testResult;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testResultService.deleteTestResult(this.testResult.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
